import * as yup from 'yup'

export const addTemplateSchema = yup.object().shape({
    name: yup.string().required('required'),
    structureId: yup.string().required('required'),
})
